module.exports = __webpack_public_path__ + "img/flag-ja.87a2742e.png";